<template>
  <v-dialog v-model="show" max-width="900px" @click:outside="closeDialog">
    <v-card>
      <v-card-title>
        <span class="headline">Stock - {{ warehouseName }}</span>
      </v-card-title>

      <v-card-text>
        <v-card v-if="!error">
          <v-data-table 
            :headers="headers" 
            :items="stockData ? stockData.containers || [] : []" 
            :items-per-page="10"
            hide-default-footer 
            disable-pagination
            :loading="loading"
            loading-text="Cargando contenedores..."
          >
            <template v-slot:item="props">
              <tr>
                <td>{{ props.index + 1 }}</td>
                <td><strong>{{ props.item.numContainer }}</strong></td>
                <td>
                  <span v-if="props.item.containerTrip">
                    Ruta #{{ props.item.containerTrip.numTrip }}
                  </span>
                  <span v-else class="grey--text">Sin viaje</span>
                </td>
                <td>
                  <span v-if="props.item.containerTrip">
                    {{ formatDate(props.item.containerTrip.datePickup) }}
                  </span>
                  <span v-else class="grey--text">-</span>
                </td>
                <td class="text-center">
                  <v-chip small :color="props.item.isAvailable ? 'success' : 'error'" dark>
                    {{ props.item.isAvailable ? 'Disponible' : 'No disponible' }}
                  </v-chip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>

        <div v-if="error" class="red--text pa-4">
          Error al cargar el stock: {{ error }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closeDialog">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { warehouseService } from "@/libs/ws/warehouseService";
import { stockWarehouseService } from "../../libs/ws/stockWarehouseService";

export default {
  props: {
    dialog: Boolean,
    warehouseId: [Number, String],
    warehouseName: String,
  },
  data() {
    return {
      show: false,
      loading: false,
      stockData: null,
      error: null,
      headers: [
        { text: "#", value: "number", width: "80px" },
        { text: "Número de Contenedor", value: "numContainer", align: "left", sortable: true },
        { text: "Ruta", value: "trip", align: "left", sortable: false },
        { text: "Fecha de Recolección", value: "datePickup", align: "left", sortable: true },
        { text: "Estado", value: "isAvailable", align: "center", sortable: true },
      ],
    };
  },
  watch: {
    dialog(val) {
      this.show = val;
      if (val) {
        this.loadStock();
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);
      this.stockData = null;
      this.error = null;
    },
    loadStock() {
      if (!this.warehouseId) return;

      this.loading = true;
      this.error = null;
      this.stockData = null;

      stockWarehouseService
        .getStockByWarehouse(this.warehouseId)
        .then((response) => {
          console.log("Stock data:", response);
          this.stockData = response;
          this.loading = false;
        })
        .catch((e) => {
          console.error("Error loading stock:", e);
          this.error = e.message || "Error desconocido";
          this.loading = false;
        });
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>
